import { CardSkeleton, FormSkeleton, SectionSkeleton } from '@/components/ui/Skeletons';

import { State } from '../State';

export function SkeletonExamples() {
  return (
    <>
      <State title="A whole form" note="Fields, then the button. Announced once.">
        <FormSkeleton fields={3} label="Loading the sample form" />
      </State>

      <State
        title="One section of a longer form"
        note="Says nothing; the page announces."
      >
        <SectionSkeleton fields={2} />
      </State>

      <State title="A card">
        <CardSkeleton lines={2} />
      </State>
    </>
  );
}
